import {Card, CardContent, Popover, Typography} from '@mui/material';
import dayjs from 'dayjs';
import {IProcessingCenterNotes} from '../../react_query/processingCenter/processingCenterQuery';
import {description} from './ProcessingTabContent';
type Props = {
  open: boolean;
  anchorEl: SVGSVGElement | null;
  handleClose: () => void;
  notes: IProcessingCenterNotes[];
};
const ProcessingPopOver = ({open, anchorEl, handleClose, notes}: Props) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}>
      <Card>
        <CardContent>
          {notes.map((notes: IProcessingCenterNotes) => (
            <Typography
              variant='subtitle1'
              color='text.secondary'
              component='div'
              key={notes.id}>
              {notes && notes.type !== undefined ? description[notes.type] : ''}
              {notes?.user?.name}
              {dayjs(notes?.created_at).format('MM/DD/YYYY hh:mm:ss A')}
            </Typography>
          ))}
        </CardContent>
      </Card>
    </Popover>
  );
};

export default ProcessingPopOver;
